export default "__VITE_PUBLIC_ASSET__feaa8a30__"